<template>
  <div class="customers-page">
    <div class="customers-section">
      <ulu-customers-charts />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-customers-charts": () =>
      import("@/components/dashboard/customers/CustomersCharts.vue"),
  }
};
</script>

<style scoped>
.customers-page {
  background-color: #f7f7f7;
  min-height: 100vh;
  padding: 24px;
}

.customers-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

@media (max-width: 768px) {
  .customers-page {
    padding: 16px;
  }
}
</style>
